import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, Table, Badge, Button, Modal, Form, Spinner, Pagination } from 'react-bootstrap';
import { FaEye, FaEyeSlash, FaEdit, FaLock, FaUserSlash, FaUserCheck } from 'react-icons/fa';
import '../styles/AdminUsuarios.css';

const ITEMS_POR_PAGINA = 15;

const AdminUsuarios = () => {
    const [usuarios, setUsuarios] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
    const [nuevaPassword, setNuevaPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [busqueda, setBusqueda] = useState('');
    const [loading, setLoading] = useState(true);
    const [paginaActual, setPaginaActual] = useState(1);
    const [showModalBaja, setShowModalBaja] = useState(false);
    const [accionBaja, setAccionBaja] = useState(null); // 'baja' o 'alta'
    
    // Estados para modal de alta de empleados
    const [showModalAlta, setShowModalAlta] = useState(false);
    const [nuevoEmpleado, setNuevoEmpleado] = useState({
        Legajo: '',
        NmEmpleado: '',
        CUIL: '',
        CodOS: '',
        CtaBanco: '',
        CtaBancoM: '',
        CBU: '',
        IdRol: 3
    });
    const [errorAlta, setErrorAlta] = useState('');
    
    // Verificar AdminLevel
    const [adminLevel, setAdminLevel] = useState(1);

    // Normalizar API_URL
    const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

    // Obtener empleados directamente con JWT
    useEffect(() => {
        console.log('🚀 useEffect ejecutándose - AdminUsuarios');
        const obtenerUsuarios = async () => {
            console.log('📞 Iniciando obtenerUsuarios()...');
            try {
                setLoading(true);
                const authToken = localStorage.getItem('token');
                const storedUser = localStorage.getItem('user');
                const user = storedUser ? JSON.parse(storedUser) : null;
                
                console.log('🔑 authToken:', authToken ? `existe (${authToken.substring(0, 20)}...)` : 'NO EXISTE');
                console.log('👤 storedUser:', storedUser ? 'existe' : 'NO EXISTE');
                console.log('👤 user parseado:', user);
                
                if (!authToken || !user) {
                    console.log('❌ DETENIDO: No hay token o user');
                    setError('No hay sesión activa');
                    setLoading(false);
                    return;
                }
                
                // Obtener AdminLevel
                const userLevel = Number(user.AdminLevel) || 1;
                setAdminLevel(userLevel);
                console.log('🔐 AdminLevel del usuario:', userLevel);

                // Obtener user ID y role de forma más robusta
                // Soporta tanto empleados (Legajo/CdEmpleado) como admins (CdUsuario)
                const userId = user.Legajo || user.CdEmpleado || user.CdUsuario || user.legajo;
                const userRole = user.IdRol || user.tipoUsuario || user.rol;

                console.log('🆔 userId extraído:', userId);
                console.log('👔 userRole extraído:', userRole);

                if (!userId) {
                    console.log('❌ DETENIDO: No se pudo extraer userId');
                    setError('Usuario sin identificador válido');
                    setLoading(false);
                    return;
                }

                console.log('🔍 Debug AdminUsuarios:');
                console.log('- authToken:', authToken ? 'existe' : 'NO EXISTE');
                console.log('- user:', user);
                console.log('- userId:', userId);
                console.log('- userRole:', userRole);
                console.log('- URL:', `${API_URL}/api/empleados`);

                const resUsuarios = await axios.get(`${API_URL}/api/empleados`, {
                    headers: {
                        'Authorization': `Bearer ${authToken}`,
                        'Content-Type': 'application/json',
                        'x-user-id': String(userId),
                        'x-user-role': String(userRole || '1')
                    }
                });

                console.log('✅ Respuesta del servidor:', resUsuarios.data);
                console.log('📊 Total de usuarios recibidos:', resUsuarios.data.length);

                const usuariosApi = resUsuarios.data.map((emp, index) => ({
                    id: index + 1,
                    legajo: emp.Legajo,
                    nombre: emp.NmEmpleado,
                    dni: emp.CUIL || 'N/A',
                    password: emp.Clave || '****',
                    mostrarPassword: false,
                    baja: emp.Baja || 0, // 0 = activo, 1 = dado de baja
                }));

                console.log('✅ Usuarios procesados:', usuariosApi.length);
                console.log('📋 Primeros 3 usuarios:', usuariosApi.slice(0, 3));

                setUsuarios(usuariosApi);
            } catch (err) {
                console.error('❌ Error al obtener datos:', err);
                console.error('❌ Error response:', err.response);
                console.error('❌ Error status:', err.response?.status);
                console.error('❌ Error data:', err.response?.data);
                setError('Error al cargar los usuarios');
            } finally {
                setLoading(false);
            }
        };

        obtenerUsuarios();
    }, [API_URL]);

    const toggleMostrarPassword = (id) => {
        setUsuarios(usuarios.map(usuario =>
            usuario.id === id
                ? { ...usuario, mostrarPassword: !usuario.mostrarPassword }
                : usuario
        ));
    };

    const handleAbrirModalCambio = (usuario) => {
        setUsuarioSeleccionado(usuario);
        setNuevaPassword('');
        setConfirmPassword('');
        setError('');
        setShowModal(true);
    };

    const handleCambiarPassword = async () => {
        if (!/^\d+$/.test(nuevaPassword)) {
            setError('La contraseña debe contener solo números');
            return;
        }

        if (nuevaPassword.length < 4) {
            setError('La contraseña debe tener al menos 4 dígitos');
            return;
        }

        if (nuevaPassword !== confirmPassword) {
            setError('Las contraseñas no coinciden');
            return;
        }

        try {
            const authToken = localStorage.getItem('token');
            const storedUser = localStorage.getItem('user');
            const user = storedUser ? JSON.parse(storedUser) : null;
            
            const payload = {
                usuario: usuarioSeleccionado.legajo.toString(),
                clave: nuevaPassword.toString()
            };

            await axios.post(`${API_URL}/api/auth/cambiar-password`, payload, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json',
                    'x-user-id': String(user?.Legajo || user?.CdEmpleado || user?.CdUsuario || ''),
                    'x-user-role': String(user?.IdRol || user?.tipoUsuario || '1')
                }
            });

            setUsuarios(prev =>
                prev.map(u =>
                    u.legajo === usuarioSeleccionado.legajo
                        ? { ...u, password: nuevaPassword }
                        : u
                )
            );

            setShowModal(false);
            setUsuarioSeleccionado(null);
            setNuevaPassword('');
            setConfirmPassword('');
        } catch (err) {
            console.error('Error al cambiar contraseña:', err);
            setError('No se pudo cambiar la contraseña');
        }
    };

    const handleAbrirModalBaja = (usuario, accion) => {
        setUsuarioSeleccionado(usuario);
        setAccionBaja(accion);
        setShowModalBaja(true);
    };

    const handleCambiarEstado = async () => {
        try {
            const authToken = localStorage.getItem('token');
            const storedUser = localStorage.getItem('user');
            const user = storedUser ? JSON.parse(storedUser) : null;
            
            const nuevoEstado = accionBaja === 'baja' ? 1 : 0;
            
            await axios.put(
                `${API_URL}/api/empleados/${usuarioSeleccionado.legajo}/baja`,
                { baja: nuevoEstado },
                {
                    headers: {
                        'Authorization': `Bearer ${authToken}`,
                        'Content-Type': 'application/json',
                        'x-user-id': String(user?.Legajo || user?.CdEmpleado || user?.CdUsuario || ''),
                        'x-user-role': String(user?.IdRol || user?.tipoUsuario || '1')
                    }
                }
            );

            // Actualizar el estado local
            setUsuarios(prev =>
                prev.map(u =>
                    u.legajo === usuarioSeleccionado.legajo
                        ? { ...u, baja: nuevoEstado }
                        : u
                )
            );

            setShowModalBaja(false);
            setUsuarioSeleccionado(null);
            setAccionBaja(null);
        } catch (err) {
            console.error('Error al cambiar estado:', err);
            alert('No se pudo cambiar el estado del usuario');
        }
    };

    // Handlers para modal de alta
    const handleAbrirModalAlta = () => {
        setNuevoEmpleado({
            Legajo: '',
            NmEmpleado: '',
            CUIL: '',
            CodOS: '',
            CtaBanco: '',
            CtaBancoM: '',
            CBU: '',
            IdRol: 3
        });
        setErrorAlta('');
        setShowModalAlta(true);
    };

    const handleCambioAlta = (campo, valor) => {
        setNuevoEmpleado(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const validarCUIL = (cuil) => {
        const cuilLimpio = cuil.replace(/[^0-9]/g, '');
        return cuilLimpio.length >= 10;
    };

    const handleCrearEmpleado = async () => {
        setErrorAlta('');

        // Validaciones
        if (!nuevoEmpleado.Legajo || !nuevoEmpleado.NmEmpleado || !nuevoEmpleado.CUIL) {
            setErrorAlta('Legajo, Nombre y CUIL son obligatorios');
            return;
        }

        if (!validarCUIL(nuevoEmpleado.CUIL)) {
            setErrorAlta('El CUIL debe tener al menos 10 dígitos');
            return;
        }

        if (!/^\d+$/.test(nuevoEmpleado.Legajo)) {
            setErrorAlta('El legajo debe contener solo números');
            return;
        }

        try {
            const authToken = localStorage.getItem('token');
            const storedUser = localStorage.getItem('user');
            const user = storedUser ? JSON.parse(storedUser) : null;

            const response = await axios.post(
                `${API_URL}/api/empleados`,
                nuevoEmpleado,
                {
                    headers: {
                        'Authorization': `Bearer ${authToken}`,
                        'Content-Type': 'application/json',
                        'x-user-id': String(user?.Legajo || user?.CdEmpleado || user?.CdUsuario || ''),
                        'x-user-role': String(user?.IdRol || user?.tipoUsuario || '1')
                    }
                }
            );

            // Agregar el nuevo empleado al estado
            const nuevoUsuario = {
                id: usuarios.length + 1,
                legajo: nuevoEmpleado.Legajo,
                nombre: nuevoEmpleado.NmEmpleado,
                dni: nuevoEmpleado.CUIL,
                password: response.data.empleado?.clave || '****',
                mostrarPassword: false,
                baja: 0
            };

            setUsuarios(prev => [...prev, nuevoUsuario]);
            setShowModalAlta(false);
            alert('Empleado creado correctamente');
        } catch (err) {
            console.error('Error al crear empleado:', err);
            const errorMsg = err.response?.data?.error || 'No se pudo crear el empleado';
            setErrorAlta(errorMsg);
        }
    };

    return (
        <>
            <Card className="main-card">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <h5>Administración de Colaboradores</h5>
                    <div className="d-flex gap-2 align-items-center">
                        {adminLevel >= 3 && (
                            <Button 
                                variant="success" 
                                size="sm"
                                onClick={handleAbrirModalAlta}
                            >
                                <FaUserCheck className="me-1" /> Dar de Alta
                            </Button>
                        )}
                        <Badge bg="primary" pill>
                            Total: {usuarios.length} Colaboradores
                        </Badge>
                    </div>
                </Card.Header>
                <div className="mb-4 px-3">
                    <Form>
                        <Form.Group controlId="busquedaLegajo">
                            <Form.Label className="fw-semibold">Buscar por Legajo</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingrese el legajo"
                                value={busqueda}
                                onChange={(e) => {
                                    setBusqueda(e.target.value);
                                    setPaginaActual(1); // Reset a página 1 cuando busca
                                }}
                                className="shadow-sm"
                                style={{ maxWidth: '300px' }}
                            />
                        </Form.Group>
                    </Form>
                </div>
                <Card.Body>
                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" role="status" variant="primary">
                                <span className="visually-hidden">Cargando...</span>
                            </Spinner>
                            <p className="mt-3">Cargando Colaboradores...</p>
                        </div>
                    ) : (() => {
                        const usuariosFiltrados = usuarios.filter((u) =>
                            u.legajo.toString().includes(busqueda.trim())
                        );
                        const totalPaginas = Math.ceil(usuariosFiltrados.length / ITEMS_POR_PAGINA);
                        const inicio = (paginaActual - 1) * ITEMS_POR_PAGINA;
                        const usuariosPaginados = usuariosFiltrados.slice(inicio, inicio + ITEMS_POR_PAGINA);

                        return (
                            <>
                                <Table hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Legajo</th>
                                            <th>Nombre</th>
                                            <th>CUIL</th>
                                            <th>Estado</th>
                                            <th>Contraseña</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usuariosPaginados.map((usuario) => (
                                            <tr key={usuario.id} className={usuario.baja === 1 ? 'table-secondary' : ''}>
                                                <td>{usuario.legajo}</td>
                                                <td>{usuario.nombre}</td>
                                                <td>{usuario.dni}</td>
                                                <td>
                                                    {usuario.baja === 1 ? (
                                                        <Badge bg="danger">Inactivo</Badge>
                                                    ) : (
                                                        <Badge bg="success">Activo</Badge>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="password-field">
                                                        {usuario.mostrarPassword ? (
                                                            <span className="text-mono">{usuario.password}</span>
                                                        ) : (
                                                            <span className="text-mono">••••••••</span>
                                                        )}
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => toggleMostrarPassword(usuario.id)}
                                                            title={usuario.mostrarPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                                        >
                                                            {usuario.mostrarPassword ? <FaEyeSlash /> : <FaEye />}
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => handleAbrirModalCambio(usuario)}
                                                            title="Cambiar contraseña"
                                                        >
                                                            <FaEdit /> Cambiar
                                                        </Button>
                                                        {adminLevel >= 3 && (
                                                            <>
                                                                {usuario.baja === 1 ? (
                                                                    <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={() => handleAbrirModalBaja(usuario, 'alta')}
                                                                        title="Dar de alta"
                                                                    >
                                                                        <FaUserCheck /> Activar
                                                                    </Button>
                                                                ) : (
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => handleAbrirModalBaja(usuario, 'baja')}
                                                                        title="Dar de baja"
                                                                    >
                                                                        <FaUserSlash /> Baja
                                                                    </Button>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                {/* Paginación */}
                                {totalPaginas > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <span className="text-muted small">
                                            Mostrando {inicio + 1} - {Math.min(inicio + ITEMS_POR_PAGINA, usuariosFiltrados.length)} de {usuariosFiltrados.length}
                                        </span>
                                        <Pagination className="mb-0">
                                            <Pagination.First 
                                                onClick={() => setPaginaActual(1)} 
                                                disabled={paginaActual === 1} 
                                            />
                                            <Pagination.Prev 
                                                onClick={() => setPaginaActual(p => Math.max(1, p - 1))} 
                                                disabled={paginaActual === 1} 
                                            />
                                            
                                            {[...Array(Math.min(5, totalPaginas))].map((_, i) => {
                                                let pageNum;
                                                if (totalPaginas <= 5) {
                                                    pageNum = i + 1;
                                                } else if (paginaActual <= 3) {
                                                    pageNum = i + 1;
                                                } else if (paginaActual >= totalPaginas - 2) {
                                                    pageNum = totalPaginas - 4 + i;
                                                } else {
                                                    pageNum = paginaActual - 2 + i;
                                                }
                                                
                                                return (
                                                    <Pagination.Item
                                                        key={pageNum}
                                                        active={pageNum === paginaActual}
                                                        onClick={() => setPaginaActual(pageNum)}
                                                    >
                                                        {pageNum}
                                                    </Pagination.Item>
                                                );
                                            })}
                                            
                                            <Pagination.Next 
                                                onClick={() => setPaginaActual(p => Math.min(totalPaginas, p + 1))} 
                                                disabled={paginaActual === totalPaginas} 
                                            />
                                            <Pagination.Last 
                                                onClick={() => setPaginaActual(totalPaginas)} 
                                                disabled={paginaActual === totalPaginas} 
                                            />
                                        </Pagination>
                                    </div>
                                )}
                            </>
                        );
                    })()}
                </Card.Body>
            </Card>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FaLock className="me-2" />
                        Cambiar contraseña
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Cambiando contraseña para: <strong>{usuarioSeleccionado?.nombre}</strong>
                    </p>

                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nueva contraseña</Form.Label>
                            <Form.Control
                                type="password"
                                value={nuevaPassword}
                                onChange={(e) => setNuevaPassword(e.target.value)}
                                placeholder="Mínimo 4 caracteres"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Confirmar contraseña</Form.Label>
                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Repita la nueva contraseña"
                            />
                        </Form.Group>

                        {error && <div className="alert alert-danger">{error}</div>}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleCambiarPassword}>
                        Confirmar Cambio
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmación de baja/alta */}
            <Modal show={showModalBaja} onHide={() => setShowModalBaja(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {accionBaja === 'baja' ? <FaUserSlash className="me-2 text-danger" /> : <FaUserCheck className="me-2 text-success" />}
                        {accionBaja === 'baja' ? 'Dar de baja usuario' : 'Activar usuario'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        ¿Está seguro que desea {accionBaja === 'baja' ? 'dar de baja' : 'activar'} al usuario:
                    </p>
                    <p className="fw-bold">
                        {usuarioSeleccionado?.nombre} (Legajo: {usuarioSeleccionado?.legajo})
                    </p>
                    {accionBaja === 'baja' && (
                        <div className="alert alert-warning">
                            <small>
                                El usuario no podrá iniciar sesión hasta que sea activado nuevamente.
                            </small>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalBaja(false)}>
                        Cancelar
                    </Button>
                    <Button 
                        variant={accionBaja === 'baja' ? 'danger' : 'success'} 
                        onClick={handleCambiarEstado}
                    >
                        Confirmar {accionBaja === 'baja' ? 'Baja' : 'Activación'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de alta de empleado */}
            <Modal show={showModalAlta} onHide={() => setShowModalAlta(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FaUserCheck className="me-2 text-success" />
                        Dar de Alta Nuevo Empleado
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Legajo <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={nuevoEmpleado.Legajo}
                                        onChange={(e) => handleCambioAlta('Legajo', e.target.value)}
                                        placeholder="Ej: 12345"
                                    />
                                    <Form.Text className="text-muted">
                                        Solo números. El CdEmpleado será igual al Legajo.
                                    </Form.Text>
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>CUIL <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={nuevoEmpleado.CUIL}
                                        onChange={(e) => handleCambioAlta('CUIL', e.target.value)}
                                        placeholder="20-12345678-9"
                                    />
                                    <Form.Text className="text-muted">
                                        La clave serán los últimos 4 dígitos del DNI.
                                    </Form.Text>
                                </Form.Group>
                            </div>
                        </div>

                        <Form.Group className="mb-3">
                            <Form.Label>Nombre Completo <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                value={nuevoEmpleado.NmEmpleado}
                                onChange={(e) => handleCambioAlta('NmEmpleado', e.target.value)}
                                placeholder="Apellido, Nombre"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Rol</Form.Label>
                            <Form.Select
                                value={nuevoEmpleado.IdRol}
                                onChange={(e) => handleCambioAlta('IdRol', parseInt(e.target.value))}
                            >
                                <option value={1}>1 - Administración</option>
                                <option value={2}>2 - Inspección</option>
                                <option value={3}>3 - Taller</option>
                                <option value={4}>4 - Conducción</option>
                            </Form.Select>
                        </Form.Group>

                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Código Obra Social</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={nuevoEmpleado.CodOS}
                                        onChange={(e) => handleCambioAlta('CodOS', e.target.value)}
                                        placeholder="Opcional"
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>CBU</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={nuevoEmpleado.CBU}
                                        onChange={(e) => handleCambioAlta('CBU', e.target.value)}
                                        placeholder="Opcional (22 dígitos)"
                                        maxLength={22}
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Cuenta Banco</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={nuevoEmpleado.CtaBanco}
                                        onChange={(e) => handleCambioAlta('CtaBanco', e.target.value)}
                                        placeholder="Opcional"
                                        maxLength={12}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Cuenta Banco M</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={nuevoEmpleado.CtaBancoM}
                                        onChange={(e) => handleCambioAlta('CtaBancoM', e.target.value)}
                                        placeholder="Opcional"
                                        maxLength={15}
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <div className="alert alert-info">
                            <small>
                                <strong>Nota:</strong> Los campos marcados con <span className="text-danger">*</span> son obligatorios.
                                La contraseña inicial serán los últimos 4 dígitos del DNI extraído del CUIL.
                            </small>
                        </div>

                        {errorAlta && <div className="alert alert-danger">{errorAlta}</div>}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalAlta(false)}>
                        Cancelar
                    </Button>
                    <Button variant="success" onClick={handleCrearEmpleado}>
                        <FaUserCheck className="me-1" /> Crear Empleado
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AdminUsuarios;